import { reviews } from '@/mocks/reviews';

export default function ReviewGrid() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 bg-secondary-100 text-secondary-700 text-xs font-medium rounded-full">
            <i className="ri-chat-quote-line"></i>
            用户口碑
          </span>
          <h2 className="mt-3 text-2xl md:text-3xl font-heading text-foreground-950">
            读者们 <span className="text-secondary-600">这样说</span>
          </h2>
          <p className="mt-2 text-sm text-foreground-500">来自数百万韩漫爱好者的真实评价</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {reviews.slice(0, 3).map((review, index) => (
            <div
              key={review.id}
              className={`rounded-lg p-6 ${
                index === 0 ? 'bg-background-50 md:col-span-1' :
                index === 1 ? 'bg-background-50 md:col-span-1 md:row-span-2' :
                'bg-background-50 md:col-span-1'
              }`}
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={review.avatar}
                    alt={review.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{review.name}</p>
                  <p className="text-xs text-foreground-500">{review.role}</p>
                </div>
              </div>
              <div className="flex items-center gap-0.5 mb-3">
                {Array.from({ length: review.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-primary-400 text-sm"></i>
                ))}
              </div>
              <i className="ri-double-quotes-l text-2xl text-secondary-300 block mb-2"></i>
              <p className="text-sm text-foreground-700 leading-relaxed">{review.comment}</p>
            </div>
          ))}

          {reviews.slice(3, 5).map((review) => (
            <div
              key={review.id}
              className="rounded-lg p-6 bg-background-50"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={review.avatar}
                    alt={review.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{review.name}</p>
                  <p className="text-xs text-foreground-500">{review.role}</p>
                </div>
              </div>
              <div className="flex items-center gap-0.5 mb-3">
                {Array.from({ length: review.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-primary-400 text-sm"></i>
                ))}
              </div>
              <i className="ri-double-quotes-l text-2xl text-secondary-300 block mb-2"></i>
              <p className="text-sm text-foreground-700 leading-relaxed">{review.comment}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}